import { memo } from "react";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

import ServiceConnectionStep from "components/ServiceConnectionStep";

// -----------------------------------------------------------------------------

const CheckingOrganizationalLevelAccessPhase = memo(
  function CheckingOrganizationalLevelAccessPhase({
    disabled,
    progressIcon,
    successIcon,
    errorIcon,
  }: CheckingOrganizationalLevelAccessPhaseProps): JSX.Element {
    return (
      <ServiceConnectionStep disabled={disabled}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {progressIcon ? (
            <CircularProgress size="24px" sx={{ mr: 1 }} />
          ) : null}
          {successIcon ? (
            <CheckCircleOutlineRoundedIcon color="success" sx={{ mr: 1 }} />
          ) : null}
          {errorIcon ? (
            <ErrorOutlineRoundedIcon color="error" sx={{ mr: 1 }} />
          ) : null}
          <Typography variant="body1">Checking Org-level access...</Typography>
        </Box>
        <Stack sx={{ mt: 2 }} spacing={1} direction="column">
          <Typography variant="body1">
            Checking to see if the Service Account provided is authorized at the
            project level or the organization level.
          </Typography>
        </Stack>
      </ServiceConnectionStep>
    );
  }
);

export default CheckingOrganizationalLevelAccessPhase;

// -----------------------------------------------------------------------------

interface CheckingOrganizationalLevelAccessPhaseProps {
  disabled: boolean;
  progressIcon: boolean;
  successIcon: boolean;
  errorIcon: boolean;
}
